function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Channel from './Channel';
import CONSTANTS from './constants';
const INPUT_EVENT = 'box_extension_input';
const OUTPUT_EVENT = 'box_extension_output';

class SafariChannel extends Channel {
  constructor(appName) {
    var _this;

    super(appName);
    _this = this;

    _defineProperty(this, "executeOperation", function () {
      let operationType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let browserToComServerTimeoutMS = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      let comServerToApplicationTimeoutSec = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      return new Promise((resolve, reject) => {
        const details = _this.buildDetailsObj(operationType, data, comServerToApplicationTimeoutSec);

        const timeoutId = setTimeout(() => {
          reject(new Error({
            status_code: CONSTANTS.REQUEST_TIMEOUT_RESPONSE_CODE
          }));
        }, browserToComServerTimeoutMS);

        _this.reqIdToPromiseMap.set(details.req_id, {
          resolve,
          rejectTimeout: timeoutId
        });

        _this.createAndDispatchAppExtensionEvent({
          detail: details
        });
      });
    });

    _defineProperty(this, "setupSafariExtensionCommunication", () => {
      if (!this.isAppExtensionListenerAttached) {
        this.isAppExtensionListenerAttached = true;
        this.document.addEventListener(OUTPUT_EVENT, this.appExtensionEventResponseHandler);
      }
    });

    _defineProperty(this, "tearDownSafariExtensionCommunication", () => {
      if (this.isAppExtensionListenerAttached) {
        this.isAppExtensionListenerAttached = false;
        this.document.removeEventListener(OUTPUT_EVENT, this.appExtensionEventResponseHandler);
      }
    });

    _defineProperty(this, "appExtensionEventResponseHandler", responseVal => {
      const response = typeof responseVal.detail === 'string' ? JSON.parse(responseVal.detail) : responseVal.detail;

      if (this.reqIdToPromiseMap.has(response.req_id)) {
        const resolveObj = this.reqIdToPromiseMap.get(response.req_id);

        if (resolveObj) {
          clearTimeout(resolveObj.rejectTimeout);
          this.reqIdToPromiseMap.delete(response.req_id);
          const responseData = typeof response.com_server_response.data === 'string' ? JSON.parse(response.com_server_response.data) : response.com_server_response.data;
          resolveObj.resolve(responseData);
        }
      }
    });

    _defineProperty(this, "createAndDispatchAppExtensionEvent", payload => {
      const {
        CustomEvent
      } = this.window;
      const eventInstance = new CustomEvent(INPUT_EVENT, payload);
      this.document.dispatchEvent(eventInstance);
    });

    _defineProperty(this, "getComServerStatus", (browserToComServerTimeoutMS, comServerToApplicationTimeoutSec) => {
      return this.executeOperation(CONSTANTS.OPERATION_STATUS, null, browserToComServerTimeoutMS, comServerToApplicationTimeoutSec);
    });

    _defineProperty(this, "sendRequest", (data, browserToComServerTimeoutMS, comServerToApplicationTimeoutSec) => {
      return this.executeOperation(CONSTANTS.OPERATION_REQUEST, data, browserToComServerTimeoutMS, comServerToApplicationTimeoutSec);
    });

    _defineProperty(this, "sendCommand", (data, browserToComServerTimeoutMS, comServerToApplicationTimeoutSec) => {
      return this.executeOperation(CONSTANTS.OPERATION_COMMAND, data, browserToComServerTimeoutMS, comServerToApplicationTimeoutSec);
    });

    _defineProperty(this, "destroy", () => {
      this.tearDownSafariExtensionCommunication();
    });

    this.reqIdToPromiseMap = new Map();
    this.channelName = CONSTANTS.SAFARI_CHANNEL_NAME;
    this.window = window;
    this.document = document;
    this.setupSafariExtensionCommunication();
  }

}

export default SafariChannel;
//# sourceMappingURL=SafariChannel.js.map